import { TaskTestSecurityPage } from './../pages/task-test-security/task-test-security';
import { TaskTestFirealarmPage } from './../pages/task-test-firealarm/task-test-firealarm';
import { TasksCompleteDetailPage } from './../pages/tasks-complete-detail/tasks-complete-detail';
import { TasksCompletePage } from './../pages/tasks-complete/tasks-complete';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { ApolloModule } from 'apollo-angular';
import { HttpLinkModule } from 'apollo-angular-link-http';
import { AppVersion } from '@ionic-native/app-version';
import { Camera } from '@ionic-native/camera';
import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { LocationProvider } from '../providers/location/location';
import { Geolocation } from '@ionic-native/geolocation';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { FCM } from '@ionic-native/fcm';

import { TasksProvider } from '../providers/tasks/tasks';
import { AuthProvider } from '../providers/auth/auth';
import { DevicesProvider } from '../providers/devices/devices';
import { UtilsProvider } from '../providers/utils/utils';
import { LoginPage } from '../pages/login/login';
import { MaintenancePage } from '../pages/maintenance/maintenance';

// TASKS PAGE
import { TasksPage } from '../pages/tasks/tasks';
import { TasksPageList } from '../pages/tasks/components/tasks/page-tasks-list';
import { TasksPageToggle } from '../pages/tasks/components/toggles/page-tasks-toggle';
import { TasksPageSearch } from '../pages/tasks/components/search/page-tasks-search';

import { InstallerTasksPage } from '../pages/installer-tasks/installer-tasks';
import { TaskDetailPage } from '../pages/task-detail/task-detail';
import { TaskCodePage } from '../pages/task-code/task-code';
import { TaskSchedulePage } from '../pages/task-schedule/task-schedule';
import { TaskPhotosPage, CommentModal } from '../pages/task-photos/task-photos';
import { TaskInvoicePage } from '../pages/task-invoice/task-invoice';
import { SchedulerModalPage } from '../pages/scheduler-modal/scheduler-modal';
import { TaskQuestionsPage } from '../pages/task-questions/task-questions';
import { TaskTestPage } from '../pages/task-test/task-test';
import { TaskCompletePage } from '../pages/task-complete/task-complete';
import { SupportPage } from '../pages/support/support';
import { ProfilePage } from '../pages/profile/profile';
import { StockPage } from '../pages/stock/stock';
import { UiProvider } from '../providers/ui/ui';
import { TypesFilter, StatusFilter } from '../providers/tasks/filters';
import { TaskCancelPage } from '../pages/task-cancel/task-cancel';
import { TaskDeclinePage } from '../pages/task-decline/task-decline';
import { TaskNotesPage } from '../pages/task-notes/task-notes';
import { ProvidersProvider } from '../providers/providers/providers';
import { UserProvider } from '../providers/users/users';
import { ControlsGeyserPage } from '../pages/controls-geyser/controls-geyser';
import { SocketProvider } from '../providers/socket/socket';


import { TaskBlockComponent } from '../components/task-block/task-block.component';

import { ZXingScannerModule } from '@zxing/ngx-scanner';
/*
  LoginPage
  TasksPage
  TaskDetailPage
  TaskCodePage
  TaskPhotosPage
  TaskQuestionsPage
  TaskTestPage
  TaskCompletePage
*/

@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    MaintenancePage,

    TasksPage,
    TasksPageList,
    TasksPageToggle,
    TasksPageSearch,

    InstallerTasksPage,
    TaskDetailPage,
    TasksCompletePage,
    TasksCompleteDetailPage,
    TaskCodePage,
    TaskSchedulePage,
    TaskPhotosPage,
    TaskInvoicePage,
    CommentModal,
    SchedulerModalPage,
    TaskQuestionsPage,
    TaskTestPage,
    TaskTestFirealarmPage,
    TaskTestSecurityPage,
    TaskCompletePage,
    TaskCancelPage,
    TaskDeclinePage,
    TaskNotesPage,
    ControlsGeyserPage,
    SupportPage,
    ProfilePage,
    StockPage,
    TypesFilter,
    StatusFilter,
    TaskBlockComponent
  ],
  imports: [
    ZXingScannerModule,
    BrowserModule,
    ApolloModule,
    HttpClientModule,
    HttpLinkModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#ff5000',
      innerStrokeColor: '#b6d0ff',
      animationDuration: 300
    }),
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(
      MyApp,
      {}
      // , // for friendly URLs
      // {
      //   links: [
      //     { component: LoginPage, name: 'Login', segment: 'login' },
      //     { component: TasksPage, name: 'Tasks', segment: 'tasks' },
      //     {
      //       component: TaskDetailPage,
      //       name: 'Task Detail',
      //       segment: 'tasks/:taskId'
      //     },
      //     {
      //       component: TaskCodePage,
      //       name: 'Task Code',
      //       segment: 'tasks/:taskId/code'
      //     },
      //     {
      //       component: TaskPhotosPage,
      //       name: 'Task Photos',
      //       segment: 'tasks/:taskId/photos'
      //     },
      //     {
      //       component: TaskQuestionsPage,
      //       name: 'Task Questions',
      //       segment: 'tasks/:taskId/questions'
      //     },
      //     {
      //       component: TaskTestPage,
      //       name: 'Task Test',
      //       segment: 'tasks/:taskId/test'
      //     },
      //     {
      //       component: TaskCompletePage,
      //       name: 'Task Complete',
      //       segment: 'tasks/:taskId/complete'
      //     },
      //     { component: SupportPage, name: 'Support', segment: 'support' }
      //   ]
      // }
    )

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    MaintenancePage,
    
    TasksPage,
    TasksPageList,
    TasksPageToggle,
    TasksPageSearch,

    InstallerTasksPage,
    TasksCompletePage,
    TasksCompleteDetailPage,
    TaskDetailPage,
    TaskCodePage,
    TaskSchedulePage,
    TaskPhotosPage,
    TaskInvoicePage,
    CommentModal,
    SchedulerModalPage,
    TaskQuestionsPage,
    TaskTestPage,
    TaskTestFirealarmPage,
    TaskTestSecurityPage,
    TaskCompletePage,
    TaskDeclinePage,
    TaskCancelPage,
    TaskNotesPage,
    ControlsGeyserPage,
    SupportPage,
    ProfilePage,
    StockPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AuthProvider,
    TasksProvider,
    DevicesProvider,
    UtilsProvider,
    UtilsProvider,
    UiProvider,
    InAppBrowser,
    LocationProvider,
    Geolocation,
    BarcodeScanner,
    AppVersion,
    Camera,
    FCM,
    ProvidersProvider,
    UserProvider,
    SocketProvider
  ],
  exports: [
    TaskBlockComponent
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts